import { useAppsStore } from "@/pinia/appsStore";
import { computed } from "vue";

/**
 * Provides consent categories from the current app, gated by the consent_enabled flag.
 *
 * Categories are sourced from `app.consent_categories` (exposed by the API via
 * Gizmo::Constants::CONSENT_CATEGORIES). `consentCategoriesEnabled` reflects the
 * consent_enabled flag. `consentCategories` returns app.consent_categories (empty array when absent).
 *
 * @returns {{ consentCategoriesEnabled: import("vue").ComputedRef<boolean>, consentCategories: import("vue").ComputedRef<Array<{value: string, label: string, description: string}>> }}
 * @example
 * const { consentCategoriesEnabled, consentCategories } = useConsentCategories();
 */
export const useConsentCategories = () => {
  const appsStore = useAppsStore();

  const consentCategoriesEnabled = computed(() => appsStore.app?.flags?.consent_enabled || false);

  const consentCategories = computed(() => appsStore.app?.consent_categories || []);

  return { consentCategoriesEnabled, consentCategories };
};
